import React, { useState } from "react";
import axios from "axios";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import Countries from "../../components/Countries";

const AddFund = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("admintoken");

  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    type: "",
    ticker: "",
    launchDate: "",
    managementFee: "",
    performanceFee: "",
    hurdleRate: "",
    NavInterval: "",
    startingNav: "",
    riskLevel: "",
    status: "",
    jurisdiction: { country: "", regulator: "" },
    investmentManager: "",
    description: "",
  });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes("jurisdiction.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        jurisdiction: { ...prev.jurisdiction, [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { managementFee, performanceFee, hurdleRate, launchDate, ...rest } =
      formData;

    const transformed = {
      ...rest,
      managementFee: parseFloat(managementFee) / 100,
      performanceFee: parseFloat(performanceFee) / 100,
      hurdleRate: parseFloat(hurdleRate) / 100,
      launchDate: new Date(launchDate).toISOString().split("T")[0],
    };

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/fund`,
        transformed,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        toast.success(res.data.message);
        navigate("/dashboard/admin/fund-management");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to create fund");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="add-bank-sec">
            <h1 className="text-center mb-4">Add New Fund</h1>
            <form onSubmit={handleSubmit} className="add-bank-sub">
              <div className="add-bank-card w-100">
                <h5>Fund Name</h5>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter fund name"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Fund Code</h5>
                <input
                  name="code"
                  value={formData.code}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter fund code"
                  required
                />
              </div>
              <div className="add-bank-card w-100">
                <h5>Ticker</h5>
                <input
                  name="ticker"
                  value={formData.ticker}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter fund ticker"
                  required
                />
              </div>
              <div className="add-bank-card w-100">
                <h5>Fund Type</h5>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select fund type</option>
                  <option value="Equity">Equity</option>
                  <option value="Fixed Income">Fixed Income</option>
                  <option value="Balanced">Balanced</option>
                  <option value="Hedge">Hedge</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Launch Date</h5>
                <input
                  type="date"
                  name="launchDate"
                  value={formData.launchDate}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Management Fee (%)</h5>
                <input
                  type="number"
                  name="managementFee"
                  value={formData.managementFee}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Performance Fee (%)</h5>
                <input
                  type="number"
                  name="performanceFee"
                  value={formData.performanceFee}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Hurdle Rate (%)</h5>
                <input
                  type="number"
                  name="hurdleRate"
                  value={formData.hurdleRate}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>NAV Interval (days)</h5>
                <input
                  type="number"
                  name="NavInterval"
                  value={formData.NavInterval}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Starting NAV</h5>
                <input
                  type="number"
                  name="startingNav"
                  value={formData.startingNav}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Risk Level</h5>
                <select
                  name="riskLevel"
                  value={formData.riskLevel}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select risk</option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Status</h5>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select status</option>
                  <option value="Active">Active</option>
                  <option value="Closed">Closed</option>
                  <option value="Suspended">Suspended</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Jurisdiction Country</h5>
                <select
                  name="jurisdiction.country"
                  value={formData.jurisdiction.country}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select country</option>
                  {Countries.map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Regulator</h5>
                <input
                  name="jurisdiction.regulator"
                  value={formData.jurisdiction.regulator}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter regulator"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Investment Manager</h5>
                <input
                  name="investmentManager"
                  value={formData.investmentManager}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                />
              </div>
              <div className="add-bank-card w-100">
                <h5>Description</h5>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="add-bank-input"
                  rows={4}
                />
              </div>

              <button type="submit" className="btn btn-lg btn-primary mt-3">
                Create Fund
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddFund;
